import loadable from '@loadable/component';

export const CyclingnewsSiteWrapper = loadable(
  () => import(/* webpackChunkName: "cyclingnews-site" */ './CyclingnewsSiteWrapper'),
);
